module.exports = __webpack_public_path__ + "img/banner-layer1.cb1a58ad.png";